'use client';

import { ContentType } from '@jlg-website/shared/constants';
import React, { useEffect, useState } from 'react';
import type { ContentType as TContentType, IconWithPack, Icon } from '@jlg-website/database/types';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import dynamic from 'next/dynamic';

const AccidentTypesForm = dynamic(
  () =>
    import('@/components/admin/contents/content-types/accident-types-form').then(
      (mod) => mod.AccidentTypesForm
    ),
  { loading: () => <>Loading...</> }
);

const fetchContentType = async () => {
  const request = await fetch(`/admin/api/content-type?name=${ContentType.AccidentTypes}`, {
    cache: 'no-store',
  });
  return request.json();
};

const fetchIcons = async () => {
  const request = await fetch(`/admin/api/icons`, {
    cache: 'no-store',
  });
  return request.json();
};

export function AccidentTypesCreateOption({ onCreate }: { onCreate: () => void }) {
  {
    const [open, setOpen] = useState(false);
    const [contentType, setContentType] = useState<TContentType | null>(null);
    const [icons, setIcons] = useState<IconWithPack[] | null>(null);

    const handleSave = () => {
      setOpen(false);
      onCreate();
    };

    useEffect(() => {
      if (!open) return;

      (async () => {
        const [contentType, icons] = await Promise.all([fetchContentType(), fetchIcons()]);

        setContentType(contentType);
        setIcons(icons);
      })();
    }, [open]);

    return (
      <Dialog
        open={open}
        onOpenChange={(value) => {
          setOpen(value);
          if (!value) setContentType(null);
        }}
      >
        <DialogTrigger asChild>
          <Button className="w-full">
            <Plus /> <strong>Create {ContentType.AccidentTypes}</strong>
          </Button>
        </DialogTrigger>
        <DialogContent className="lg:min-w-3xl gap-0 p-0">
          <DialogHeader className="shrink-0 px-6 pt-6 pb-0">
            <DialogTitle>Create content</DialogTitle>
          </DialogHeader>
          {contentType && (
            <div className="flex-1 overflow-y-auto px-6 pt-4 pb-6">
              <AccidentTypesForm
                contentType={contentType}
                onSave={handleSave}
                icons={icons as Icon[]}
                customCancelButton={
                  <DialogClose asChild>
                    <Button variant="outline">Cancel</Button>
                  </DialogClose>
                }
              />
            </div>
          )}
        </DialogContent>
      </Dialog>
    );
  }
}

export default AccidentTypesCreateOption;
